export const isNotEmptyArray = (arrayLike: unknown): boolean =>
  Array.isArray(arrayLike) && arrayLike.length > 0;
